import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/patient";

export const getPageAllPatient = (dto) => {
  let url = API_PATH + "/paging-patient";
  return axios.post(url, dto);
};
